import type { FormEventHandler } from 'react';

export function withFormData<K extends string>(call: (params: Record<K, string>) => void, keys?: K[]): FormEventHandler<HTMLFormElement> {
    return (e) => {
        const formData = new FormData(e.currentTarget);

        const params = {} as Record<K, string>;
        formData.forEach((value, key) => {
            if (!keys || (keys as string[]).includes(key)) {
                if (typeof value === 'string') {
                    params[key as K] = value;
                }
            }
        });

        call(params);
    };
}
